import firebase, { database } from "../firebase";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import * as actionTypes from "../actionTypes";
import * as constants from "../Constatnts";
import alertSound from "../audio/audio/electronic-school-bell-81033.mp3";
import axios from "axios";
export function inventoryPreConditions(  registration,
  store,
  transactionType,
  transaction = null) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/transaction/inventorypreconditions?registration=${registration}&store=${store}&transactionType=${transactionType}&transaction=${transaction}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

 return { Status: response.data.Status, Message: response.data.Message };
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}

// Helper method to adjust color brightness
export function adjustColorBrightness(color, percent) {
  // If color is in hex format
  if (color.startsWith('#')) {
    const r = parseInt(color.slice(1, 3), 16);
    const g = parseInt(color.slice(3, 5), 16);
    const b = parseInt(color.slice(5, 7), 16);
    
    const adjustedR = Math.min(255, Math.max(0, r + (r * percent / 100)));
    const adjustedG = Math.min(255, Math.max(0, g + (g * percent / 100)));
    const adjustedB = Math.min(255, Math.max(0, b + (b * percent / 100)));
    
    return `#${Math.round(adjustedR).toString(16).padStart(2, '0')}${Math.round(adjustedG).toString(16).padStart(2, '0')}${Math.round(adjustedB).toString(16).padStart(2, '0')}`;
  }
  return color;
}

export function isDarkColor  (hex) {
  const color = hex.replace('#', '');
  const r = parseInt(color.substr(0, 2), 16);
  const g = parseInt(color.substr(2, 2), 16);
  const b = parseInt(color.substr(4, 2), 16);

  const brightness = (r * 299 + g * 587 + b * 114) / 1000;
  return brightness < 128;
};
export function getModules() {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/setup/getmodules`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data.modules;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}









export function getToastr(
  message,
  options = null,
  type = "success",
  props = null,
  stopAlert = null,
  notificationType = "",
  notificationTitle = ""
) {
  return (dispatch) => {
    if (options) {
      if (!options.hasOwnProperty("positionClass")) {
        options.positionClass = "toast-bottom-right no-print";
      }
      toastr.options = options;
    } else {
      toastr.options = {
        positionClass: "toast-bottom-right no-print",
        hideDuration: 300,
        timeOut: 5000,
      };
    }
    if (type === "success") toastr.success(message);
    else {
      toastr.options = {
        closeButton: true,
        debug: false,
        newestOnTop: true,
        progressBar: false,
        positionClass: "toast-bottom-right no-print",
        preventDuplicates: true,
        showDuration: "300",
        hideDuration: "1000",
        timeOut: "5000",
        extendedTimeOut: 0,
        showEasing: "swing",
        hideEasing: "linear",
        showMethod: "fadeIn",
        hideMethod: "fadeOut",
        tapToDismiss: false,
      };

      if (notificationType === "order") {
        toastr.options.onclick = function() {
          stopAlert();
          props.history.push({
            pathname: "/home/sales/onlineorders",
            state: {
              orderID: "",
              transactionType: null,
              type: actionTypes.ONLINE_ORDER,
            },
          });
        };
        toastr.info(message, "Order Placed!!");
      } else if (notificationType === "onlineorder") {
        //
        const audio = new Audio(alertSound);
        toastr.options.onShown = function() {
          // const audio = new Audio('https://drive.google.com/uc?export=download&id=1M95VOpto1cQ4FQHzNBaLf0WFQglrtWi7');
          audio.play();
        };
        toastr.options.onclick = function() {
          // stopAlert()
          audio.pause();
          audio.currentTime = 0;
          props.history.push({ pathname: "/home/sales/deliverylist" });
          // window.location.reload(false);
        };
        toastr.options.onCloseClick = function() {
          console.log("onclose click");
          audio.pause();
          audio.currentTime = 0;
        };
        toastr.options.onHidden = function() {
          console.log("onHidden");
          audio.pause();
          audio.currentTime = 0;
        };
        toastr.info(message, "");
      } else if (notificationType === "fcm") {
        toastr.info(message, notificationTitle);
      }
    }
  };
}

export function getVisibility(module, access) {
  return (dispatch, getState) => {
    let visibility = true;
    if (module === "Products" && getState().user && getState().user.acl) {
      console.log(
        "acl",
        getState().user.acl.filter((e) => e.id === module)
      );
    }
    if (getState().user.acl) {
      if (access === "create")
        visibility = getState()
          .user.acl.filter((e) => e.id === module)
          .map((acl) => acl.perms.create)[0];
      else if (access === "read")
        visibility = getState()
          .user.acl.filter((e) => e.id === module)
          .map((acl) => acl.perms.read)[0];
      else if (access === "update")
        visibility = getState()
          .user.acl.filter((e) => e.id === module)
          .map((acl) => acl.perms.update)[0];
      else if (access === "delete")
        visibility = getState()
          .user.acl.filter((e) => e.id === module)
          .map((acl) => acl.perms.delete)[0];
      else if (access === "export")
        visibility = getState()
          .user.acl.filter((e) => e.id === module)
          .map((acl) => acl.perms.export)[0];
    }
    return visibility ? "inline" : "none";
  };
}

export function showModule(module, access = "read") {
  return (dispatch, getState) => {
    let visibility = false;

    if (
      getState().user.user.Role === "Power User" ||
      getState().user.user.Role === "Store Owner" ||
      getState().user.user.Role === "Store Manager" ||
      getState().user.user.Role === "Store Cashier"
    ) {
      // if (getState().user.acl) {
      //     if (access === "create")
      //         visibility = getState().user.acl.filter((e) => e.id === module).map((acl) => acl.perms.create)[0];
      //     else if (access === "read")
      //         visibility = getState().user.acl.filter((e) => e.id === module).map((acl) => acl.perms.read)[0];
      //     else if (access === "update")
      //         visibility = getState().user.acl.filter((e) => e.id === module).map((acl) => acl.perms.update)[0];
      //     else if (access === "delete")
      //         visibility = getState().user.acl.filter((e) => e.id === module).map((acl) => acl.perms.delete)[0];
      //     else if (access === "export")
      //         visibility = getState().user.acl.filter((e) => e.id === module).map((acl) => acl.perms.export)[0];
      // }
      visibility = true;
    } else {
      if (
        getState().user.acl.filter((e) => e.id === module && e.perms.read)
          .length > 0
      ) {
        // console.log('i.TransactionType', i.TransactionType);
        // console.log('perms', this.props.user.acl.filter(e=>e.id === i.TransactionType && e.perms.read));
        visibility = true;
      }
    }
    return visibility;
  };
}

// export function getVisibility(module, access) {
//     return (dispatch, getState) => {
//         let visibility = true
//         if (getState().user.acl) {
//             if (access === "create")
//                 visibility = getState().user.acl.filter((e) => e.id === module).map((acl) => acl.perms.create)[0];
//             else if (access === "read")
//                 visibility = getState().user.acl.filter((e) => e.id === module).map((acl) => acl.perms.read)[0];
//             else if (access === "update")
//                 visibility = getState().user.acl.filter((e) => e.id === module).map((acl) => acl.perms.update)[0];
//             else if (access === "delete")
//                 visibility = getState().user.acl.filter((e) => e.id === module).map((acl) => acl.perms.delete)[0];
//             else if (access === "export")
//                 visibility = getState().user.acl.filter((e) => e.id === module).map((acl) => acl.perms.export)[0];
//         }
//         return visibility ? "inline" : "none"
//     }
// }

export function uploadFile(file,folderName) {
    return async (dispatch, getState) => {
  try {
    console.log("267 upload file");
    const formData = new FormData();
    formData.append('file', file);
     formData.append('folderName', 'helpdesk');
    
      const token = getState().user.uat;

      const response = await axios.post(
        constants.API_URL + "/uploadfile",
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`,
          },
        }
      );
   
    
    return response.data;
  } catch (error) {
    console.error('Image upload failed:', error);
    throw error;
  }
}
};
export function importCSV(
  filePath,
  importType,
  fileName,
  emailID,
  productImportType,
  forStoreID,
  forStore,
  overWriteExistingCustomerData = false
) {
  return async (dispatch, getState) => {
    try {
      let params = {
        filePath: filePath,
        importType: importType,
        fileName: fileName,
        emailID: emailID,
        productImportType: productImportType,
        forStoreID: forStoreID,
        forStore: forStore,
        overWriteExistingCustomerData: overWriteExistingCustomerData,
        StoreID: getState().user.store.key,
      };

      const token = getState().user.uat;

      const response = await axios.post(
        constants.API_URL + "/uploadFileToServer",
        params,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.code == "0") {
        return response.data.id;
      } else {
        throw new Error(response.data.message || "Failed to import CSV");
      }
    } catch (error) {
      console.error("Error importing CSV:", error.message);
      throw error;
    }
  };
}

export function getImportDetails(key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/getimportdetails/${key}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data.data;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}



export function sendEmail(email) {
  return async (dispatch, getState) => {
    try {
      const user = getState().user.user;
      const token = getState().user.uat;
      const response = await axios.post(
        constants.API_URL + "/sendemail",
        email,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    
      if(response.data.code=="0"){
      return response.data.docId
      }
      else{
          throw new Error(response.data.message || "Failed to send email");
          return null;
      }
    } catch (error) {
      console.error("Error sending email:", error.response || error.message);
      throw error;
    }
  };
}
export function sendSMS(sms) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.post(
        `${constants.API_URL}/sendsms`,
        sms,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data.code === "0";
    } catch (error) {
      console.error("API Error in sendSMS:", error);
      return false;
    }
  };
}



export function getPrintTemplate(template) {
  // console.log(template);
  return (dispatch) => {
    return database
      .collection("PrintTemplates")
      .doc(template)
      .get()
      .then((doc) => {
        if (doc.exists) {
          // console.log(doc.data().PrintTemplate);
          return doc.data();
        } else {
          console.log("No such template found!");
        }
      });
  };
}

export function getImportLogList(type) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/getimportloglist/${type}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data.data;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}

export function getImportLogs(key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/getimportlogs/${key}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data.data;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}


export function convertNumberToWords(amount) {
  return (dispatch) => {
    var words = new Array();
    words[0] = "";
    words[1] = "One";
    words[2] = "Two";
    words[3] = "Three";
    words[4] = "Four";
    words[5] = "Five";
    words[6] = "Six";
    words[7] = "Seven";
    words[8] = "Eight";
    words[9] = "Nine";
    words[10] = "Ten";
    words[11] = "Eleven";
    words[12] = "Twelve";
    words[13] = "Thirteen";
    words[14] = "Fourteen";
    words[15] = "Fifteen";
    words[16] = "Sixteen";
    words[17] = "Seventeen";
    words[18] = "Eighteen";
    words[19] = "Nineteen";
    words[20] = "Twenty";
    words[30] = "Thirty";
    words[40] = "Forty";
    words[50] = "Fifty";
    words[60] = "Sixty";
    words[70] = "Seventy";
    words[80] = "Eighty";
    words[90] = "Ninety";
    amount = amount.toString();
    var atemp = amount.split(".");
    var number = atemp[0].split(",").join("");
    var n_length = number.length;
    var words_string = "";
    if (n_length <= 9) {
      var n_array = new Array(0, 0, 0, 0, 0, 0, 0, 0, 0);
      var received_n_array = new Array();
      for (var i = 0; i < n_length; i++) {
        received_n_array[i] = number.substr(i, 1);
      }
      for (var i = 9 - n_length, j = 0; i < 9; i++, j++) {
        n_array[i] = received_n_array[j];
      }
      for (var i = 0, j = 1; i < 9; i++, j++) {
        if (i == 0 || i == 2 || i == 4 || i == 7) {
          if (n_array[i] == 1) {
            n_array[j] = 10 + parseInt(n_array[j]);
            n_array[i] = 0;
          }
        }
      }
      let value = "";
      for (var i = 0; i < 9; i++) {
        if (i == 0 || i == 2 || i == 4 || i == 7) {
          value = n_array[i] * 10;
        } else {
          value = n_array[i];
        }
        if (value != 0) {
          words_string += words[value] + " ";
        }
        if (
          (i == 1 && value != 0) ||
          (i == 0 && value != 0 && n_array[i + 1] == 0)
        ) {
          words_string += "Crores ";
        }
        if (
          (i == 3 && value != 0) ||
          (i == 2 && value != 0 && n_array[i + 1] == 0)
        ) {
          words_string += "Lakhs ";
        }
        if (
          (i == 5 && value != 0) ||
          (i == 4 && value != 0 && n_array[i + 1] == 0)
        ) {
          words_string += "Thousand ";
        }
        if (
          i == 6 &&
          value != 0 &&
          n_array[i + 1] != 0 &&
          n_array[i + 2] != 0
        ) {
          words_string += "Hundred and ";
        } else if (i == 6 && value != 0) {
          words_string += "Hundred ";
        }
      }
      words_string = words_string.split("  ").join(" ");
    }
    return "Rupees " + words_string;
  };
}

export function addDays(days) {
  return (dispatch) => {
    var date = new Date();
    date.setDate(date.getDate() + days);
    return date;
  };
}
export function saveDataForBarcodePrint(barcodePrintData) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.post(
        `${constants.API_URL}/barcodeprint`,
        barcodePrintData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.code === "0") {
        return response.data.data.key;
      } else {
        return false;
      }
    } catch (error) {
      console.error("API Error:", error);
      return false;
    }
  };
}


export function isMobileApp() {
  return (dispatch) => {
    // return true //window cordova
    if (window.screen.width <= 480) {
      return true;
    } else {
      return false;
    }
  };
}

export function onStoreChangeResetConfig() {
  return (dispatch) => {
    let state = null;
    dispatch({ type: actionTypes.STORE_RESET_CONFIG, state });
  };
}

export function setSmartStores(SmartStores) {
  return (dispatch) => {
    dispatch({ type: actionTypes.SET_SMART_STORES, SmartStores });
  };
}

export function onStoreChangeResetUser() {
  return (dispatch) => {
    let state = null;
    dispatch({ type: actionTypes.STORE_RESET_USER, state });
  };
}

export function connectBlueToothPrinter() {
  return (dispatch) => {
    let connected = {};
    // alert("window" + window)
    window.BTPrinter.connect(
      (data) => {
        if (data.name && data.address) {
          connected = {
            PrinterName: data.name,
            PrinterAddress: data.address,
          };
        }
        alert("successfully connected");
        return connected;
      },
      (error) => {
        alert("error " + error);
        return null;
      }
    );
  };
}

export function printTextBlueToothPrinter(
  printerName,
  printerAddress,
  printText,
  printAlignment,
  printFontSize,
  printLineSpacing
) {
  return (dispatch, getState) => {
    alert("printText:" + printText);
    return window.BTPrinter.printText(
      (data) => {
        alert(JSON.stringify(data));
        return JSON.stringify(data);
      },
      (err) => {
        alert(JSON.stringify(err));
        console.log("Error");
        console.log(err);
        return JSON.stringify(err);
      },
      {
        name: printerName,
        address: printerAddress,
        text: printText,
        alignment: printAlignment === "" ? "center" : printAlignment, // center, left, right
        fontSize: printFontSize === "" ? "normal" : printFontSize, // large, normal
        lineSpacing: printLineSpacing === "" ? 5 : printLineSpacing,
      }
    );
  };
}

export function onInventoryLineItemChange(
  lineItem,
  placeOfSupply,
  computeTax = true,
  transactionType
) {
  return (dispatch, getState) => {
    let includePriceAndTax = false;
    if (transactionType.hasOwnProperty("IncludePriceAndTax")) {
      includePriceAndTax = transactionType.IncludePriceAndTax;
    }
    if (!includePriceAndTax) {
      lineItem.SubTotal = 0;
      lineItem.ChargeTaxOnProduct = false;
      lineItem.TaxInclusive = false;
      lineItem.DiscountPer = 0;
      lineItem.DiscountAmount = 0;
      lineItem.SubTotalWithDiscount = 0;
      lineItem.TaxableAmount = 0;
      lineItem.TaxComponentAmount = [];
      lineItem.TotalTax = 0;
      lineItem.Amount = 0;
      return lineItem;
    }

    let subTotal = this.roundUpTo2(
      Number(lineItem.SupplyPrice) * Number(lineItem.Qty)
    );
    let discountAmt;
    let discountPer;
    if (
      Number(lineItem.DiscountAmount) > 0 &&
      Number(lineItem.DiscountPer) === 0
    ) {
      //calculate discount per based on discount amount
      discountPer = Number(
        (
          (Number(lineItem.DiscountAmount) * 100) /
          Number(lineItem.SubTotal)
        ).toFixed(3)
      );
      discountAmt = this.roundUpTo2(lineItem.DiscountAmount);
    } else {
      discountPer = Number(lineItem.DiscountPer);
      discountAmt = this.roundUpTo2(
        (Number(subTotal) * Number(lineItem.DiscountPer)) / 100
      );
    }
    let subTotalWithDiscount = this.roundUpTo2(
      Number(subTotal) - Number(discountAmt)
    );
    let chargeTaxOnProduct = lineItem.ChargeTaxOnProduct;
    let priceBasedTax = lineItem.PriceBasedTax;
    let taxInclusive = lineItem.TaxInclusive;
    let taxableAmount = 0;
    let totalTax = 0;
    let amount = 0;
    let taxComponentAmount = [];
    let supplyPriceWithoutTax = 0; //TBD

    if (chargeTaxOnProduct && computeTax) {
      if (priceBasedTax) {
        let unitPriceAfterDiscount = this.roundUpTo2(
          Number(subTotalWithDiscount) / Number(lineItem.Qty)
        );
        //console.log('unitPriceAfterDiscount',unitPriceAfterDiscount)
        //console.log('lineItem.Product.TaxPriceRange',lineItem.Product.TaxPriceRange)
        lineItem.Product.TaxPriceRange.map((t) => {
          if (
            Number(unitPriceAfterDiscount) >= Number(t.FromPrice) &&
            Number(unitPriceAfterDiscount) <= Number(t.ToPrice)
          ) {
            lineItem.TaxID = t.TaxID;
            lineItem.TaxGroup = t.TaxGroup;
            return;
          }
        });
      }
      let taxfound = false;
      let customerFromSameState = true; //TBD IMP IMP

      if (placeOfSupply !== "" && getState().user.store.State !== "") {
        if (
          placeOfSupply.toLowerCase() !==
          getState().user.store.State.toLowerCase()
        ) {
          customerFromSameState = false;
        }
      }
      getState()
        .config.ProductTaxes.filter((t) => t.key === lineItem.TaxID.trim())
        .map((taxGroup, index) => {
          taxfound = true;
          let taxAmount = 0;
          let taxComponentTemp = [];
          taxGroup.Taxes.map((t) => {
            if (
              customerFromSameState &&
              (t.TaxType === "CGST" || t.TaxType === "SGST")
            ) {
              taxComponentTemp.push({
                TaxName: t.TaxName,
                TaxPercentage: Number(t.TaxPercentage),
                TaxType: t.TaxType,
                TaxAmount: 0,
              });
            } else if (!customerFromSameState && t.TaxType === "IGST") {
              taxComponentTemp.push({
                TaxName: t.TaxName,
                TaxPercentage: Number(t.TaxPercentage),
                TaxType: t.TaxType,
                TaxAmount: 0,
              });
            } else if (
              t.TaxType !== "CGST" &&
              t.TaxType !== "IGST" &&
              t.TaxType !== "SGST"
            ) {
              taxComponentTemp.push({
                TaxName: t.TaxName,
                TaxPercentage: Number(t.TaxPercentage),
                TaxType: t.TaxType,
                TaxAmount: 0,
              });
            }
          });

          if (taxInclusive) {
            //tax inclusive
            let totalTaxRate = 0;
            taxComponentTemp.map((t) => {
              totalTaxRate = this.roundUpTo2(
                Number(t.TaxPercentage) + Number(totalTaxRate)
              );
            });
            totalTax = this.roundUpTo2(
              (Number(subTotalWithDiscount) * Number(totalTaxRate)) /
                (100 + Number(totalTaxRate))
            );
            taxableAmount = this.roundUpTo2(
              Number(subTotalWithDiscount) - Number(totalTax)
            );
            amount = this.roundUpTo2(subTotalWithDiscount);
            taxComponentTemp.map((t) => {
              taxAmount = this.roundUpTo2(
                (Number(totalTax) *
                  ((Number(t.TaxPercentage) * 100) / Number(totalTaxRate))) /
                  100
              );
              taxComponentAmount.push({
                TaxName: t.TaxName,
                TaxPercentage: Number(t.TaxPercentage),
                TaxType: t.TaxType,
                TaxAmount: taxAmount,
              });
            });
          } else {
            taxableAmount = subTotalWithDiscount;
            taxComponentTemp.map((t) => {
              taxAmount = this.roundUpTo2(
                (Number(taxableAmount) * Number(t.TaxPercentage)) / 100
              );
              totalTax = this.roundUpTo2(Number(totalTax) + Number(taxAmount));
              taxComponentAmount.push({
                TaxName: t.TaxName,
                TaxPercentage: Number(t.TaxPercentage),
                TaxType: t.TaxType,
                TaxAmount: taxAmount,
              });
            });
            amount = this.roundUpTo2(taxableAmount + totalTax);
          }
        });
      //tax is not found then
      if (!taxfound) {
        //alert("Tax not found for selected product. Please check item ")
        taxableAmount = 0;
        taxComponentAmount = [];
        totalTax = 0;
        amount = subTotalWithDiscount;
      }
    } else {
      taxableAmount = 0;
      taxComponentAmount = [];
      totalTax = 0;
      amount = subTotalWithDiscount;
    }
    // lineItem.Qty = qty
    // lineItem.RetailPrice = price
    lineItem.SubTotal = this.roundUpTo2(subTotal);
    lineItem.ChargeTaxOnProduct = chargeTaxOnProduct;
    lineItem.TaxInclusive = taxInclusive;
    lineItem.DiscountPer = this.roundUpTo2(discountPer);
    lineItem.DiscountAmount = this.roundUpTo2(discountAmt);
    lineItem.SubTotalWithDiscount = this.roundUpTo2(subTotalWithDiscount);
    lineItem.TaxableAmount = this.roundUpTo2(taxableAmount);
    lineItem.TaxComponentAmount = taxComponentAmount;
    lineItem.TotalTax = this.roundUpTo2(totalTax);
    lineItem.Amount = this.roundUpTo2(amount);
    return lineItem;
  };
}

export function getStateCodeMaster() {
  return (dispatch) => {
    let states = [
      { code: 1, name: "1-JAMMU AND KASHMIR" },
      { code: 2, name: "2-HIMACHAL PRADESH" },
      { code: 3, name: "3-PUNJAB" },
      { code: 4, name: "4-CHANDIGARH" },
      { code: 5, name: "5-UTTARAKHAND" },
      { code: 6, name: "6-HARYANA" },
      { code: 7, name: "7-DELHI" },
      { code: 8, name: "8-RAJASTHAN" },
      { code: 9, name: "9-UTTAR PRADESH" },
      { code: 10, name: "10-BIHAR" },
      { code: 11, name: "11-SIKKIM" },
      { code: 12, name: "12-ARUNACHAL PRADESH" },
      { code: 13, name: "13-NAGALAND" },
      { code: 14, name: "14-MANIPUR" },
      { code: 15, name: "15-MIZORAM" },
      { code: 16, name: "16-TRIPURA" },
      { code: 17, name: "17-MEGHALAYA" },
      { code: 18, name: "18-ASSAM" },
      { code: 19, name: "19-WEST BENGAL" },
      { code: 20, name: "20-JHARKHAND" },
      { code: 21, name: "21-ORISSA" },
      { code: 22, name: "22-CHHATTISGARH" },
      { code: 23, name: "23-MADHYA PRADESH" },
      { code: 24, name: "24-GUJARAT" },
      { code: 25, name: "25-DAMAN AND DIU" },
      { code: 26, name: "26-DADAR AND NAGAR HAVELI" },
      { code: 27, name: "27-MAHARASTRA" },
      { code: 29, name: "29-KARNATAKA" },
      { code: 30, name: "30-GOA" },
      { code: 31, name: "31-LAKSHADWEEP" },
      { code: 32, name: "32-KERALA" },
      { code: 33, name: "33-TAMIL NADU" },
      { code: 34, name: "34-PUDUCHERRY" },
      { code: 35, name: "35-ANDAMAN AND NICOBAR" },
      { code: 36, name: "36-TELANGANA" },
      { code: 37, name: "37-ANDHRA PRADESH" },
      { code: 97, name: "97-OTHER TERRITORY" },
      { code: 99, name: "99-OTHER COUNTRY" },
    ];
    return states;
  };
}

export function getModeOfTransport() {
  return (dispatch) => {
    let modeOfTransport = [
      {
        Code: "1",
        Name: "Road",
      },
      {
        Code: "2",
        Name: "Rail",
      },
      {
        Code: "3",
        Name: "Air",
      },
      {
        Code: "4",
        Name: "Ship",
      },
    ];
    return modeOfTransport;
  };
}

export function getVehicleType() {
  return (dispatch) => {
    let vehicleType = [
      {
        Code: "R",
        Name: "Regular",
      },
      {
        Code: "O",
        Name: "ODC(Over Dimentional Cargo)",
      },
    ];
    return vehicleType;
  };
}

export function setPageFilters(
  page,
  searchParameters,
  searchText,
  recordFrom,
  activePage,
isFilterActive) {
  return (dispatch, getState) => {
    // console.log("page", page);
    // console.log("page", searchParameters);

    let pageFilters = getState().config.PageFilters;
    // console.log("pageFilters", JSON.stringify(pageFilters));

    if (pageFilters.filter((f) => f.PageName === page).length > 0) {
      // console.log('found')
      pageFilters.map((m) => {
        if (m.PageName === page) {
          m.PageFilters = searchParameters;
          m.SearchText = searchText ? searchText : "";
          m.RecordFrom = recordFrom ? recordFrom : 0;
          m.ActivePage = activePage ? activePage : 0;
          m.IsFilterActive=isFilterActive ? isFilterActive : false
          // console.log("pageFilters", m.PageFilters);
        }
      });
    } else {
      pageFilters.push({
        PageName: page,
        PageFilters: searchParameters,
        SearchText: searchText ? searchText : "",
        RecordFrom: recordFrom ? recordFrom : 0,
        ActivePage: activePage ? activePage : 0,
        IsFilterActive:isFilterActive ? isFilterActive : false
      });
    }
    dispatch({ type: actionTypes.PUSH_PAGE_FILTERS_TO_REDUX, pageFilters });
  };
}

export function getPageFilters(page) {
  return (dispatch, getState) => {
    let objPage = getState().config.PageFilters.filter(
      (f) => f.PageName === page
    );
    if (objPage.length > 0) {
      if (objPage[0].hasOwnProperty("SearchText")) {
        return {
          PageFilters: objPage[0].PageFilters,
          SearchText: objPage[0].SearchText,
          RecordFrom: objPage[0].RecordFrom ? objPage[0].RecordFrom : 0,
          ActivePage: objPage[0].ActivePage ? objPage[0].ActivePage : 1,
          IsFilterActive:objPage[0].IsFilterActive,
        };
      } else {
        return objPage[0].PageFilters;
      }
    } else {
      return null;
    }
  };
}


export function saveDashboardSettings(key, dashboardSettings) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      let response = {};

      if (key !== "") {
        // Update existing account
        response = await axios.put(
          `${constants.API_URL}/dashboard/setting/${key}`,
          dashboardSettings,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } else {
        // Create new account
        response = await axios.post(
          `${constants.API_URL}/dashboard/setting`,
          dashboardSettings,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }

      if (response.data.code === "0") {
        if (key) {
          return key;
        } else {
          return response.data.data.key;
        }
      }

      return null;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}

export function getDashBoardSettings() {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/dashboard/settings`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data.dashboardSetting;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}


export function getFoodDeliveryPlatforms() {
  return (dispatch) => {
    let foodDeliveryPlatforms = [
      {
        Code: "swiggystore",
        Name: "Swiggy Stores",
      },
      {
        Code: "zomatomarket",
        Name: "Zomato Market",
      },
      {
        Code: "swiggy",
        Name: "Swiggy",
      },
      {
        Code: "zomato",
        Name: "Zomato",
      },
      {
        Code: "ubereats",
        Name: "Uber Eats",
      },
      {
        Code: "urbanpiper",
        Name: "Urban piper",
      },
      {
        Code: "satellite",
        Name: "Satellite",
      },
    ];
    return foodDeliveryPlatforms;
  };
}

// export function getYears()
// {
//     return (dispatch) => {
//         let years = [2018, 2019, 2020];
//         return years
//     }
// }

export function getYears() {
  return (dispatch) => {
    let years = [2026, 2025, 2024, 2023, 2022, 2021, 2020, 2019, 2018];
    return years;
  };
}

export function getMonths(year) {
  return (dispatch) => {
    let months = [];
    months.push({ Month: 0, MonthName: "January" });
    months.push({ Month: 1, MonthName: "February" });
    months.push({ Month: 2, MonthName: "March" });
    months.push({ Month: 3, MonthName: "April" });
    months.push({ Month: 4, MonthName: "May" });
    months.push({ Month: 5, MonthName: "June" });
    months.push({ Month: 6, MonthName: "July" });
    months.push({ Month: 7, MonthName: "August" });
    months.push({ Month: 8, MonthName: "September" });
    months.push({ Month: 9, MonthName: "October" });
    months.push({ Month: 10, MonthName: "November" });
    months.push({ Month: 11, MonthName: "December" });
    return months;
  };
}

export function getStartDateOfMonth(year, month) {
  return (dispatch) => {
    var firstDay = new Date(year, month, 1);
    let fromDate = new Date(firstDay).setHours(23, 59);
    console.log("startDate", new Date(fromDate).toISOString().split("T")[0]);
    return new Date(fromDate).toISOString().split("T")[0];
  };
}

export function getEndDateOfMonth(year, month) {
  console.log("year", year);
  console.log("month", month);

  return (dispatch) => {
    var lastDay = new Date(year, Number(month) + 1, 0);
    let toDate = new Date(lastDay).setHours(23, 59);
    console.log("endDate", new Date(toDate).toISOString().split("T")[0]);
    return new Date(toDate).toISOString().split("T")[0];
  };
}

//Offline Start
export function saveConnectionStatus(status, action) {
  // console.log(status);
  return (dispatch) => {
    let connectionStatus = {
      Status: status === true ? "connected" : "disconnected",
    };
    dispatch({ type: actionTypes.GET_CONNECTION_STATUS, connectionStatus });
  };
}

//Offline End

export function isElectron() {
  return (dispatch, getState) => {
    return false;
    if (typeof require !== "function") return false;
    if (typeof window !== "object") return false;
    try {
      const electron = require("electron");
      if (typeof electron !== "object") return false;
    } catch (e) {
      return false;
    }
    return true;
  };
}

export function getPetTypes() {
  return (dispatch) => {
    let petTypes = [];
    petTypes.push({ Value: "Dogs", Name: "Dogs" });
    petTypes.push({ Value: "Cats", Name: "Cats" });
    petTypes.push({ Value: "Fish", Name: "Fish" });
    petTypes.push({ Value: "Birds", Name: "Birds" });
    petTypes.push({ Value: "Others", Name: "Others" });
    return petTypes;
  };
}

export function getPetBreeds() {
  return (dispatch) => {
    let petBreeds = [];
    petBreeds.push({
      Type: "Dogs",
      Value: "Labrador Retriever",
      Name: "Labrador Retriever",
    });
    petBreeds.push({
      Type: "Dogs",
      Value: "German Shepherd",
      Name: "German Shepherd",
    });
    petBreeds.push({
      Type: "Dogs",
      Value: "Golden Retriever",
      Name: "Golden Retriever",
    });
    petBreeds.push({ Type: "Dogs", Value: "Dachshund", Name: "Dachshund" });
    petBreeds.push({ Type: "Dogs", Value: "Beagle", Name: "Beagle" });
    petBreeds.push({ Type: "Dogs", Value: "Boxer", Name: "Boxer" });
    petBreeds.push({
      Type: "Dogs",
      Value: "Tibetan Mastiff",
      Name: "Tibetan Mastiff",
    });
    petBreeds.push({
      Type: "Dogs",
      Value: "English Cocker Spaniel",
      Name: "English Cocker Spaniel",
    });
    petBreeds.push({ Type: "Dogs", Value: "Pug", Name: "Pug" });
    petBreeds.push({ Type: "Dogs", Value: "Rottweiler", Name: "Rottweiler" });
    petBreeds.push({ Type: "Dogs", Value: "Doberman", Name: "Doberman" });
    petBreeds.push({ Type: "Dogs", Value: "Great Dane", Name: "Great Dane" });
    petBreeds.push({ Type: "Dogs", Value: "Pomeranian", Name: "Pomeranian" });
    petBreeds.push({ Type: "Dogs", Value: "Dalmatian", Name: "Dalmatian" });
    petBreeds.push({
      Type: "Dogs",
      Value: "Indian Spitz",
      Name: "Indian Spitz",
    });
    petBreeds.push({ Type: "Dogs", Value: "Pekingese", Name: "Pekingese" });
    petBreeds.push({ Type: "Dogs", Value: "Akita", Name: "Akita" });
    petBreeds.push({ Type: "Dogs", Value: "St. Bernard", Name: "St. Bernard" });
    petBreeds.push({
      Type: "Dogs",
      Value: "Bichon Frise",
      Name: "Bichon Frise",
    });
    petBreeds.push({
      Type: "Dogs",
      Value: "French Bulldog",
      Name: "French Bulldog",
    });
    petBreeds.push({
      Type: "Dogs",
      Value: "English Bulldog",
      Name: "English Bulldog",
    });
    petBreeds.push({
      Type: "Dogs",
      Value: "Yorkshire Terrier",
      Name: "Yorkshire Terrier",
    });
    petBreeds.push({ Type: "Dogs", Value: "Cane Corso", Name: "Cane Corso" });
    petBreeds.push({ Type: "Dogs", Value: "Chow Chow", Name: "Chow Chow" });
    petBreeds.push({ Type: "Dogs", Value: "Maltese", Name: "Maltese" });
    petBreeds.push({ Type: "Dogs", Value: "Poodle", Name: "Poodle" });
    petBreeds.push({
      Type: "Dogs",
      Value: "Siberian Hasky",
      Name: "Siberian Hasky",
    });
    petBreeds.push({ Type: "Dogs", Value: "Shihtzu", Name: "Shihtzu" });
    petBreeds.push({ Type: "Dogs", Value: "Pitbull", Name: "Pitbull" });
    petBreeds.push({ Type: "Dogs", Value: "Indian Dog", Name: "Indian Dog" });

    petBreeds.push({ Type: "Cats", Value: "Bombay Cat", Name: "Bombay Cat" });
    petBreeds.push({
      Type: "Cats",
      Value: "Himalayan Cat",
      Name: "Himalayan Cat",
    });
    petBreeds.push({ Type: "Cats", Value: "Siamese Cat", Name: "Siamese Cat" });
    petBreeds.push({ Type: "Cats", Value: "Persian Cat", Name: "Persian Cat" });
    petBreeds.push({ Type: "Cats", Value: "Maine Coon", Name: "Maine Coon" });
    petBreeds.push({
      Type: "Cats",
      Value: "The American Bobtail",
      Name: "The American Bobtail",
    });
    petBreeds.push({ Type: "Cats", Value: "Spotted Cat", Name: "Spotted Cat" });

    petBreeds.push({ Type: "Birds", Value: "Dove", Name: "Dove" });
    petBreeds.push({
      Type: "Birds",
      Value: "Zebra Finches",
      Name: "Zebra Finches",
    });
    petBreeds.push({
      Type: "Birds",
      Value: "Hyacinth Macaw",
      Name: "Hyacinth Macaw",
    });
    petBreeds.push({
      Type: "Birds",
      Value: "Pineapple Conures",
      Name: "Pineapple Conures",
    });
    petBreeds.push({ Type: "Birds", Value: "Cockatiels", Name: "Cockatiels" });
    petBreeds.push({ Type: "Birds", Value: "Parrotlet", Name: "Parrotlet" });
    petBreeds.push({ Type: "Birds", Value: "Budgies", Name: "Budgies" });
    petBreeds.push({
      Type: "Birds",
      Value: "Hahn’s Macaw",
      Name: "Hahn’s Macaw",
    });
    petBreeds.push({ Type: "Birds", Value: "Love Birds", Name: "Love Birds" });

    petBreeds.push({ Type: "Fish", Value: "Betta Fish", Name: "Betta Fish" });
    petBreeds.push({ Type: "Fish", Value: "Guppy Fish", Name: "Guppy Fish" });
    petBreeds.push({
      Type: "Fish",
      Value: "Flowerhorn Fish",
      Name: "Flowerhorn Fish",
    });
    petBreeds.push({ Type: "Fish", Value: "Gold Fish", Name: "Gold Fish" });
    petBreeds.push({ Type: "Fish", Value: "Koi Fish", Name: "Koi Fish" });
    petBreeds.push({ Type: "Fish", Value: "Oscar Fish", Name: "Oscar Fish" });
    petBreeds.push({ Type: "Fish", Value: "Catfishes", Name: "Catfishes" });
    petBreeds.push({
      Type: "Fish",
      Value: "Grass Carp Fish",
      Name: "Grass Carp Fish",
    });

    return petBreeds;
  };
}






